import { EVENT_BUS } from '@/eventBus';

export default function process(event) {
  if (!event) {
    console.error('[error in socket process]');
    return;
  }

  const data = JSON.parse(event.data);
  console.log('SOCKET::PROCESS::DATA', data.event, data);

  switch (data.event) {
    case 'CRYPTO_PARTIAL_ACCRUAL':
      EVENT_BUS.$emit('EVENT_CRYPTO_PARTIAL_ACCRUAL', data);
  }
}
